// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import {
  ImageWithCaption
} from '../../ImageWithCaption'

import { BootstrapImage } from '../../../../dsl/bootstrap'
import NoSSR from 'vue-no-ssr'
import VueEasyLightbox from 'vue-easy-lightbox'
import { Image } from '../../../_contracts'

@Component<ArticleHeaderImage>({
  name: 'ArticleHeaderImage',
  components: {
    BootstrapImage,
    ImageWithCaption,
    NoSSR,
    VueEasyLightbox
  },

  template: `
    <div class="article-header__image">
      <template v-if="hasThumbnail">
        <ImageWithCaption
          v-if="thumbnail"
          :image="thumbnail"
          :hideDescription="hideDescription"
          :overridenCaption="caption"
          :isLazy="isLazy"
          :fetchPriority="!isLazy"
          @click="openFullScreenPreview"
        >
          <slot name="video" />

          <slot name="ad" />
        </ImageWithCaption>
      </template>
      <template v-else>
        <BootstrapImage :src="fallbackImage" />

        <slot name="video" />

        <slot name="ad" />
      </template>

      <NoSSR>
        <VueEasyLightbox
          v-if="!hasVideo && thumbnail"
          :visible="isFullScreenPreviewOpen"
          :imgs="thumbnail.fullscreen"
          @hide="closeFullScreenPreview"
        />
      </NoSSR>
    </div>
  `
})
export class ArticleHeaderImage extends Vue {
  @Prop({ type: String, required: false, default: '' })
  public readonly fallbackImage!: string

  @Prop({ type: String, required: false })
  public readonly caption!: string | undefined

  @Prop({ type: Boolean, required: false, default: true })
  public hideDescription!: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  public isLazy!: boolean;

  @Prop({ type: Object, required: false, default: null })
  public thumbnail!: Image | null;

  /**
   * Determines whether the image is displayed in fullscreen mode
   */
  public isFullScreenPreviewOpen: boolean = false

  /**
   * Checking that content has a cover photo - Thumbnail
   */
  public get hasThumbnail (): boolean {
    return !!this.thumbnail
  }

  public get hasVideo (): boolean {
    return this.$slots.video !== undefined && this.$slots.video.length > 0
  }

  /**
   * Closes fullscreen view of the image
   */
  public closeFullScreenPreview (): void {
    this.isFullScreenPreviewOpen = false
  }

  /**
   * Opens image in the fullscreen mode
   */
  public openFullScreenPreview (): void {
    this.isFullScreenPreviewOpen = true
  }
}
